module.exports = __webpack_public_path__ + "static/media/3.72ef7138.png";